import React, { useState } from 'react';
import { Upload, Icon } from '@tencent/tea-component';
import classnames from 'classnames';
import CropperModal from 'src/components/CropperModal';
import useCropper from '../useCropper';
import { Toast } from '@tencent/calendar-web-component-mobile';
import { CoverItem } from '../CoverSetting';
import styles from './index.module.scss';

export interface CosInfo {
  url: string;
  cosId: string;
}
interface IProps {
  aspectRatio: number;
  coverInfo: CoverItem;
  onUploadComplete: (data?: CosInfo) => void;
  tipMessage?: React.ReactNode;
  className?: string;
  size?: 'mini' | 'normal';
}

const SingleUpload: React.FC<IProps> = (props) => {
  const { coverInfo, onUploadComplete, aspectRatio, tipMessage, size = 'normal' } = props;

  const {
    modalVisible,
    setModalVisible,
    handleModalCancel,
    handleModalConfirm,
    setFileUrl,
    fileUrl,
    setSelectFile,
  } = useCropper();
  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [dataUrl, setDataUrl] = useState('');
  // 上传前
  const handleBeforeUpload = (file: File, fileList: Array<File>, accept = true) => {
    if (!accept) {
      if (fileList.length >= 2) {
        Toast.fail('不支持单次上传多张图片');
        return false;
      }
      Toast.fail('请上传5兆以下的png/jpg/jpeg图片');
      return false;
    }
    const windowURL = window.URL || window.webkitURL; // 兼容操作
    const dataURl = windowURL.createObjectURL(file);
    setModalVisible(true);
    setFileUrl(dataURl);
    setSelectFile(file);
    return true;
  };

  // 裁剪确认后
  const customConfirm = (base64: string) => {
    setLoading(true);
    setUploadError(false);
    handleModalConfirm(base64).then(
      (data) => {
        onUploadComplete(data);
        setLoading(false);
        setUploadError(false);
      },
      () => {
        setLoading(false);
        setUploadError(true);
      },
    );
    setDataUrl(base64);
  };

  const handleReupload = () => {
    customConfirm(dataUrl);
  };

  const isMini = size === 'mini';

  return (
    <div className={classnames(styles.wrapper, props.className, { [styles.mini]: isMini })}>
      <div className={classnames('coverItem', { isLoading: loading })} key={coverInfo?.cuttedCosId}>
        {coverInfo.origin && !loading && !uploadError && (
          <img className="coverImg" src={coverInfo?.cutted || coverInfo?.origin} />
        )}
        {(loading || uploadError) && (
          <div className={classnames(styles.loading, uploadError ? styles.uploadError : '')}>
            {uploadError ? (
              <>
                <Icon
                  type="error"
                  // size="m"
                  className={styles.errorIcon}
                />
                <div className={styles.errorTip}>
                  上传失败，<span onClick={handleReupload}>重试</span>
                </div>
              </>
            ) : (
              <>
                <Icon type="loading" size="s" className={styles.loadingIcon} />
                上传中...
              </>
            )}
          </div>
        )}
        <div className="actions">
          <Upload
            accept="image/png,image/jpeg,image/gif"
            maxSize={1024 * 1024 * 5}
            beforeUpload={handleBeforeUpload}
          >
            <div className={styles.edit} />
          </Upload>
        </div>
      </div>
      {tipMessage}
      <CropperModal
        showTip
        onCancel={handleModalCancel}
        onConfirm={customConfirm}
        aspectRatio={aspectRatio}
        showModal={modalVisible}
        imgUrl={fileUrl}
      />
    </div>
  );
};

export default SingleUpload;
